/**
 * react-hook-form v5 + React 18: register's ref callback may return a cleanup.
 * Swallow that return so React does not warn about callback refs.
 */
export function bindRef(register, options) {
  return (element) => {
    if (!element) return
    if (options) {
      void register(options)(element)
    } else {
      void register(element)
    }
  }
}
